var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "estate-card-data" }, [
    _vm.estate.rooms
      ? _c(
          "div",
          { staticClass: "estate-card-data-element estate-card-rooms" },
          [
            _vm._t("estate-rooms", function() {
              return [
                _c("masked-image", { attrs: { src: "/img/icons/rooms.svg" } }),
                _vm._v(" "),
                _vm.estate.rooms_short
                  ? _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.estate.rooms_short) }
                    })
                  : _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.estate.rooms) }
                    })
              ]
            })
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.estate.bedrooms_small
      ? _c(
          "div",
          { staticClass: "estate-card-data-element estate-card-rooms" },
          [
            _vm._t("estate-rooms", function() {
              return [
                _c("masked-image", { attrs: { src: "/img/icons/rooms.svg" } }),
                _vm._v(" "),
                _c("span", {
                  domProps: { innerHTML: _vm._s(_vm.estate.bedrooms_small) }
                })
              ]
            })
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.estate.surface
      ? _c(
          "div",
          { staticClass: "estate-card-data-element estate-card-surface" },
          [
            _vm._t("estate-surface", function() {
              return [
                _c("masked-image", {
                  attrs: { src: "/img/icons/surface.svg" }
                }),
                _vm._v(" "),
                _c("span", {
                  domProps: { innerHTML: _vm._s(_vm.estate.surface) }
                })
              ]
            })
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.estate.solutions_count
      ? _c(
          "div",
          { staticClass: "estate-card-data-element estate-card-solutions" },
          [
            _vm._t("estate-solutions", function() {
              return [
                _c("masked-image", {
                  attrs: { src: "/img/icons/solutions.svg" }
                }),
                _vm._v(" "),
                _c("span", {
                  domProps: { innerHTML: _vm._s(_vm.estate.solutions_count) }
                })
              ]
            })
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.estate.bathrooms
      ? _c(
          "div",
          { staticClass: "estate-card-data-element estate-card-bathrooms" },
          [
            _vm._t("estate-bathrooms", function() {
              return [
                _c("masked-image", {
                  attrs: { src: "/img/icons/bathrooms.svg" }
                }),
                _vm._v(" "),
                _c("span", {
                  domProps: { innerHTML: _vm._s(_vm.estate.bathrooms) }
                })
              ]
            })
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }